module.exports = __webpack_public_path__ + "images/lvyue3.jpg?v=0fc5439d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/lvyue3.jpg
 ** module id = 113
 ** module chunks = 1 2
 **/